import provenenanceBlog from './provenanceBlog';
import traceabilityBlog from './traceabilityBlog';
import graduateBlog from './lucasNovember2018';
import graduateImg from '../img/blog/graduate.jpg';
import provencanceImg from '../img/blog/provenance.jpg';
import traceabilityImg from '../img/blog/traceability.jpg';

const welcometodistilledid = {
  path: 'welcome-to-distilled-ID',
  title: 'Welcome to distilled ID',
};

const graduate = {
  path: 'meet-lucas-our-graduate-engineer',
  title: 'Meet Lucas - our Graduate Engineer',
};

const traceability = {
  path: 'blockchain-traceability-combating-counterfeiting-and-parallel-trading',
  title: 'Blockchain Traceability – Combating counterfeiting and...',
};

const provenance = {
  path: 'provenance-without-the-facts-and-evidence-it-is-just-a-story',
  title: 'Provenance – without the facts and evidence it’s just a story',
};

export default [
  {
    path: 'provenance-without-the-facts-and-evidence-it-is-just-a-story',
    date: '2018-11-15',
    content: 'Provenance – without the facts and evidence it’s just a story',
    heading: 'DISTILLED ID',
    image: provencanceImg,
    component: provenenanceBlog,
    previous: graduate,
    next: welcometodistilledid,
  },
  {
    path: 'meet-lucas-our-graduate-engineer',
    date: '2018-11-18',
    content: 'Meet Lucas - our Graduate Engineer',
    heading: 'arc-net',
    image: graduateImg,
    component: graduateBlog,
    previous: traceability,
    next: provenance,
  },
  {
    path: 'blockchain-traceability-combating-counterfeiting-and-parallel-trading',
    date: '2018-11-19',
    content: 'Blockchain Traceability – Combating counterfeiting and...',
    heading: 'DISTILLED ID',
    image: traceabilityImg,
    component: traceabilityBlog,
    previous: provenance,
    next: graduate,
  },
];



// WEBPACK FOOTER //
// ./src/blogposts/index.js